export function getTimezone() {
  if (Intl.DateTimeFormat) {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  }

  // modern browsers might never need the code below
  const offset = new Date().getTimezoneOffset();
  return `${offset}`;
}
